
export function initFxScroll() {
    // Controllo rapido: Esistono elementi da animare allo scroll?
    // Controlliamo il selettore di default definito in fx_scroll.js
    const hasScrollElements = document.querySelector('[data-fx-animation]');

    if (hasScrollElements) {
        // Import Dinamico: Scarica FxScroll E anime.js solo ora
        import('./scroll/fx_scroll')
            .then(({ FxScroll }) => {
                new FxScroll();
            })
            .catch(err => console.error('Error loading FxScroll:', err));
    }
}
